const pagesPersonCsvImportEn = {
  breadcrumb: 'Add members by CSV',
  detail: {
    applyButton: 'Import this data',
    backToList: 'Back to list',
    chunkLabel: 'Chunk {{index}}',
    chunkLoading: 'Loading chunk results...',
    errorSummary: {
      cells: 'cells',
      downloadErrorRows: 'Download error rows',
      title: 'Errors'
    },
    failureReason: {
      csvParseFailed: 'Failed to parse the CSV file. Please check the format.',
      emptyCsvFile: 'The CSV file is empty.',
      noValidRows: 'No valid rows to import. Fix the errors below and upload the file again.',
      unknown: 'The import failed. Please try again.'
    },
    progress: {
      errors: 'Errors',
      importedCount: 'Imported',
      importing: 'Importing data...',
      valid: 'Valid',
      validating: 'Checking the uploaded file...'
    },
    toolbar: {
      errorChip: 'Error',
      export: 'Export',
      filter: 'Filter',
      searchPlaceholder: 'Filter by name...',
      share: 'Share'
    },
    totalLabel: 'Total {{unit}}',
    unit: {
      boardMember: 'board members',
      collaborator: 'collaborators',
      contractor: 'contractors',
      employee: 'employees'
    }
  },
  dialog: {
    field: {
      boardMemberType: 'Board member type',
      collaboratorType: 'Collaborator type',
      contractTerm: 'Contract period',
      contractorType: 'Contractor type',
      employmentType: 'Employment type',
      joinDate: 'Join date',
      name: 'Name'
    },
    requiredLabel: 'Required',
    title: 'Select member type'
  },
  errors: {
    conflict: 'This file is already being processed.',
    enqueueFailed: 'Failed to start the import. Please try again.',
    notFound: 'The import could not be found.'
  },
  list: {
    columns: {
      fileName: 'File name',
      importedAt: 'Imported at',
      importedCount: 'Imported',
      status: 'Progress'
    },
    detailButton: 'View details',
    empty: 'No import history yet.',
    pageDescription: 'You can add data for multiple people. A CSV file following the DRESS CODE format is required.',
    title: 'Member CSV import',
    uploadButton: 'Add CSV file'
  },
  memberType: {
    boardMember: 'Board member',
    collaborator: 'Collaborator',
    contractor: 'Contractor',
    employee: 'Employee'
  },
  status: {
    applied: 'Import complete',
    applyFailed: 'Import failed',
    applying: 'Importing',
    partiallyApplied: 'Partially imported',
    validateFailed: 'Validation failed',
    validated: 'Awaiting review',
    validating: 'Validating'
  },
  stepper: {
    completed: 'Import complete',
    importing: 'Importing',
    upload: 'Upload',
    validated: 'Validation complete',
    validating: 'Validating'
  }
};
export default pagesPersonCsvImportEn;